import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@nomoh-monorepo/data-access-auth';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'lib-access-denied',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  template: `
    <div class="access-denied-container">
      <div class="access-denied-card">
        <i
          class="pi pi-exclamation-triangle"
          style="font-size: 4rem; color: #f56565;"
        ></i>
        <h1>{{ 'ACCESS_DENIED.TITULO' | translate }}</h1>
        <p>{{ 'ACCESS_DENIED.MENSAGEM' | translate }}</p>
        <p>
          {{ 'ACCESS_DENIED.CONTATO' | translate }}
        </p>

        <div class="actions">
          <button type="button" class="btn-back" (click)="goBack()">
            <i class="pi pi-arrow-left"></i>
            {{ 'ACCESS_DENIED.BOTOES.VOLTAR' | translate }}
          </button>

          <button type="button" class="btn-home" (click)="goHome()">
            <i class="pi pi-home"></i>
            {{ 'ACCESS_DENIED.BOTOES.INICIO' | translate }}
          </button>

          <button type="button" class="btn-logout" (click)="logout()">
            <i class="pi pi-sign-out"></i>
            {{ 'ACCESS_DENIED.BOTOES.SAIR' | translate }}
          </button>
        </div>
      </div>
    </div>
  `,
  styles: [
    `
      .access-denied-container {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 100vh;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        padding: 1rem;
      }

      .access-denied-card {
        background: white;
        border-radius: 1rem;
        padding: 3rem;
        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
        text-align: center;
        max-width: 500px;
        width: 100%;
      }

      h1 {
        color: #2d3748;
        margin: 1rem 0;
        font-size: 2rem;
      }

      p {
        color: #718096;
        margin: 0.5rem 0;
        line-height: 1.6;
      }

      .actions {
        display: flex;
        gap: 1rem;
        justify-content: center;
        margin-top: 2rem;
      }

      button {
        padding: 0.75rem 1.5rem;
        border: none;
        border-radius: 0.5rem;
        cursor: pointer;
        font-weight: 500;
        display: flex;
        align-items: center;
        gap: 0.5rem;
        transition: all 0.3s ease;
      }

      .btn-back {
        background: #e2e8f0;
        color: #4a5568;
      }

      .btn-back:hover {
        background: #cbd5e0;
      }

      .btn-home {
        background: #3182ce;
        color: white;
      }

      .btn-home:hover {
        background: #2c5282;
      }

      .btn-logout {
        background: #e53e3e;
        color: white;
      }

      .btn-logout:hover {
        background: #c53030;
      }
    `,
  ],
})
export class AccessDeniedComponent {
  private router = inject(Router);
  private authService = inject(AuthService);

  goBack(): void {
    window.history.back();
  }

  goHome(): void {
    this.router.navigate(['/dashboard']);
  }

  async logout(): Promise<void> {
    await this.authService.logout();
    this.router.navigate(['/login']);
  }
}
